import instanceQuery from 'graphql/queries/schedules/BusinessRuleParameterQuery.graphql';
import mutationQuery from 'graphql/mutations/schedules/BusinessRuleParameterMutation.graphql';
import fragment from 'graphql/fragments/schedules/BusinessRuleParameterFragment.graphql';
import listQuery from 'graphql/queries/schedules/BusinessRuleParameterListQuery.graphql';

const BusinessRuleParameter = {
  type: 'BusinessRuleParameter',
  title: 'Business Rule Parameters',
  formTitle: 'Business Rule Parameter',
  formUrl: '',
  workspaceUrl: '',
  instance: instanceQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'className',
  },
  fragment,
};

export default BusinessRuleParameter;
